import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";

export const GET_ALL_QUERY = print(gql`
  query PartnerCompanies($page: Int, $perPage: Int, $search: String, $active: Boolean) {
    PartnerCompanies(page: $page, perPage: $perPage, search: $search, active: $active) {
      items {
        id
        name
        active
      }
      paginationInfo {
        page
        perPage
        hasMore
        totalPages
        totalData
        nextPage {
          page
          perPage
        }
      }
    }
  }
`);

export interface GetAllItem {
  id: number;
  name: string;
  active: boolean;
}

export interface GetAllGql {
  PartnerCompanies: {
    items: GetAllItem[];
    paginationInfo: PaginationInfo;
  };
}
